import React, { FC, memo, useCallback, useState } from 'react';
import { ScreenInputFormFeature } from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../redux/user/selector';
import { useIsKeyBoardShown } from '../../shared';
import { updateUserPersonalData } from '../../api/user';
import { setUser } from '../../redux/user/reducer';
import useToast from '../../context/ToastContext/ToastContext';

type ProfileFirstNameWidgetProps = {
  onSuccess?: (val: string) => void;
};

const ProfileFirstNameWidget: FC<ProfileFirstNameWidgetProps> = ({ onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector(userSelector);

  const { t } = useTranslation('auth');
  const isKeyboardShown = useIsKeyBoardShown();
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const handleSubmit = useCallback(
    async (value: string) => {
      try {
        setIsLoading(true);
        const { data, error, message } = await updateUserPersonalData({
          display_name: value,
        });

        if (error) {
          throw new Error(message ? t(message) : 'Something went wrong');
        }

        dispatch(setUser(data));
        onSuccess?.(data.display_name);
      } catch (e: any) {
        showToast({ message: e?.message });
      } finally {
        setIsLoading(false);
      }
    },
    [onSuccess]
  );

  return (
    <>
      <ScreenInputFormFeature
        type={'text'}
        title={t('google_apple_sign_up.create_name.title')}
        buttonText={t('auth.button.next')}
        defaultValue={user?.display_name}
        name={'display_name'}
        required={true}
        isFocus={true}
        isKeyboardShown={isKeyboardShown}
        isLoading={isLoading}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default memo(ProfileFirstNameWidget);
